import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { class: "label is-inline-flex is-align-items-center" }, [
  /*#__PURE__*/_createVNode("span", null, "Registration Type")
], -1)
const _hoisted_3 = { class: "control is-expanded" }
const _hoisted_4 = {
  key: 0,
  class: "icon has-text-warning"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("span", null, _toDisplayString(_ctx.registrationType), 1),
      _createVNode(_component_tooltip, {
        class: "registration-type-tooltip-icon is-inline ml-2",
        content: _ctx.tooltipContent,
        position: 'bottom',
        filter: 'span'
      }, {
        default: _withCtx(() => [
          (_ctx.isRegistrationTypeUnknown)
            ? (_openBlock(), _createBlock("span", _hoisted_4, [
                _hoisted_5
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["content"])
    ])
  ]))
}